export default function() {
  const widgetName = 'cardWidgetFairSponsors';
  const widgetOpts = cardWidgetFairSponsorsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $('<h3>Sponsors</h3>').insertBefore(`#${widgetName}`);
      $(`#${widgetName} .card-widget-item`).attr('target', '_blank');

      const lastItem = data.items.slice(-1)[0];
      if (lastItem.Title.toLowerCase() === 'button') {
        const btnText = lastItem.DetailLinkText;
        const btnURL = lastItem.URL;
        $(`<a href="${btnURL}" target="_blank" class="button button--blue">${btnText}</a>`).insertAfter(`#${widgetName}`);
        $(`#${widgetName} .card-widget-item`).last().remove();
      }

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: false,
      margin: 10,
      navText: ['Prev','Next'],
      nav: false
    },
    textOverImage: false
  });

}